import React__default from 'react';
import SvgIcon from '../../node_modules/@mui/material/SvgIcon/SvgIcon.esm.js';

const PlayRectangleWithoutGradientIcon = (props) => (React__default.createElement(SvgIcon, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 49, height: 25, fill: "none", viewBox: "0 0 45 24" }, props),
    React__default.createElement("rect", { width: 48, height: 24, x: 0.085, fill: "#2B59E0", rx: 12, transform: "rotate(.131 .085 0)" }),
    React__default.createElement("path", { fill: "#fff", d: "M30.56 11.204a1 1 0 0 1-.004 1.732l-9.012 5.175a1 1 0 0 1-1.498-.87L20.07 6.85a1 1 0 0 1 1.502-.863l8.988 5.217Z" })));

export { PlayRectangleWithoutGradientIcon };
